export default __webpack_public_path__ + "static/media/return.11889a3b.svg";